import React from "react";
import { useSearchParams } from "react-router-dom";

export default function CppComplier() {
  const [searchParams] = useSearchParams();
  const fileId = searchParams.get('fileId');

  // Build the iframe URL with or without fileId
  const iframeSrc = fileId 
    ? `/cpp_compiler/index.html?fileId=${fileId}`
    : `/cpp_compiler/index.html`;

  return (
    <iframe
      src={iframeSrc}
      style={{
        position: "fixed",
        top: 0,
        left: 60,
        width: "calc(100vw - 60px)",
        height: "100vh",
        border: "none",
      }}
    />
  );
}